import React from "react";
import general_helper from "../helpers/general_helper";
import formatter from "../helpers/number_formatter";
import DeliveryItem from "../components/dashboard/DeliveryItem";
import DeliveryMetaCard from "../components/MetaCard";
import quick_models from "../network/models/quick_models";

const CheckoutPage = () => {
    let deliveryItem = quick_models.createDeliveryOrderResponse;

    return (
        <div>
            <div className="mainWrapper" style={{marginTop: 55}}>
                <div className="container">

                    <div className="row justify-content-center" style={{marginLeft: 45, marginRight: 45}}>
                        <div className="col-md-5">
                            <div className="row no-gutters">
                                <div className="col-6 text-left">
                                    <p className="small-text-grey">Status</p>
                                    <h6>
                                        {"ZNG-298388"}
                                    </h6>
                                </div>
                                <div className="col-6 text-right">
                                <span
                                    className="badge badge-pill badge-primary">{general_helper.displayCurrentDeliveryStatus(deliveryItem.status)}</span>
                                    <h6>
                                        GH{formatter.accounting.formatMoney(90.00, "¢ ")}
                                    </h6>
                                </div>
                            </div>
                            <br/>
                            <DeliveryItem delivery={{item: deliveryItem, index: 0, showCTA: false}}/>
                            <br/>
                            <br/>
                            <br/>
                            <small>Pick Up Location details</small>
                            <DeliveryMetaCard
                                data={{title: deliveryItem.pick_up.name, subTitle: deliveryItem.pick_up.phone_number}}/>
                            <small>Drop-off Location details</small>
                            <DeliveryMetaCard
                                data={{
                                    title: deliveryItem.drop_off.address,
                                    subTitle: deliveryItem.drop_off.phone_number
                                }}/>
                            <button className="btn btn-primary btn-md btn-block">
                                PAY
                            </button>
                            <small className="text-center">Cancel</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutPage;
